import * as React from "react";
import { useContext } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import WidgetDetailsContext from "report/report-creation/WidgetDetailsContext";
import ReportParameters from "./ReportParameters";
import WidgetsList from "./WidgetsList";
import AddWidget from "./AddWidget";
const Header = styled.h3`
  margin-bottom: 15px;
`;
const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-items: center;
  justify-content: space-between;
`;
const Content = ({ editAllowed, scopeLocked = false }) => {
  const { t } = useTranslation("enterprise_report");
  const { searchIds, parameters } = useContext(WidgetDetailsContext);
  const widgetsLocked = !editAllowed || scopeLocked;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, Object.keys(parameters).length > 0 ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(HeaderContainer, null, /* @__PURE__ */ React.createElement(Header, null, t("report_parameters.required_parameters"))), /* @__PURE__ */ React.createElement(ReportParameters, { parameters, parameterSearchIds: searchIds })) : null, /* @__PURE__ */ React.createElement(HeaderContainer, null, /* @__PURE__ */ React.createElement(Header, null, t("content.widgets")), /* @__PURE__ */ React.createElement(AddWidget, { disabled: widgetsLocked })), /* @__PURE__ */ React.createElement(WidgetsList, { disabled: widgetsLocked }));
};
export default Content;
